if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Re-query at submit time — cart-drawer may not have been ready at construct (slow 3G)
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          this.cart;

        const submitButtons = Array.from(this.querySelectorAll('button[type="submit"]'));
        const submitButton =
          evt.submitter && submitButtons.includes(evt.submitter) && evt.submitter.offsetParent !== null
            ? evt.submitter
            : submitButtons.find((button) => button.offsetParent !== null) || this.submitButton;

        // Mobile ATC is type=button (#sizeSelector) — keep its spinner in sync with the real submit
        const mobileAtc = this.querySelector('#sizeSelector');
        const loadingButtons = [submitButton];
        if (mobileAtc && mobileAtc !== submitButton) loadingButtons.push(mobileAtc);

        if (submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        loadingButtons.forEach((button) => {
          button.setAttribute('aria-disabled', true);
          button.classList.add('loading');
          const spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        
        /*
        * Product Display Page
        * Aftership Final Sale Line Item Property Addition - Start
        * Add _ASRC when the variant is on sale, or the product type is listed
        * in shop.metafields.custom.final_sale_product_types and the product
        * is not tagged final-sale:false.
        */
        if (variantId && typeof AFTERSHIP_PROPERTIES !== 'undefined' && AFTERSHIP_PROPERTIES.ENABLE_FINAL_SALE_PROPERTY) {
          try {
            let compareAtPrice = null;
            let price = null;
            const variantDataScript = document.getElementById('product-variant-data');
            if (variantDataScript) {
              const variantData = JSON.parse(variantDataScript.textContent);
              const variant = Array.isArray(variantData)
                ? variantData.find((v) => v && v.id != null && v.id.toString() === variantId.toString())
                : null;
              if (variant) {
                compareAtPrice = variant.compare_at_price;
                price = variant.price;
              }
            }

            const propertyKey = `properties[${AFTERSHIP_PROPERTIES.FINAL_SALE_KEY}]`;
            if (
              typeof shouldSetFinalSaleProperty === 'function' &&
              !formData.get(propertyKey) &&
              shouldSetFinalSaleProperty(
                compareAtPrice,
                price,
                this.dataset.productType,
                this.dataset.finalSaleExempt === 'true'
              )
            ) {
              formData.append(propertyKey, AFTERSHIP_PROPERTIES.FINAL_SALE_VALUE);
            }
          } catch (e) {
            console.error('Error adding final sale line item property:', e);
          }
        }
        /*
        * Aftership Final Sale Line Item Property Addition - End
        */        
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              submitButton.setAttribute('aria-disabled', true);
              submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Prefer drawer/notification if it appeared after construct — never hard-redirect to /cart
              this.cart =
                document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (!this.cart) {
                console.error('Add to cart succeeded but cart drawer/notification was not found');
                return;
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            
            // Store the variant ID for complete look section update
            const variantId = formData.get('id');
            if (variantId) {
              localStorage.setItem('latestAddedVariantId', variantId);
              console.log('Stored variant ID in localStorage:', variantId);
            }
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            loadingButtons.forEach((button) => {
              button.classList.remove('loading');
              const spinner = button.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
              if (!this.error) button.removeAttribute('aria-disabled');
            });
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
